import React, {Component} from 'react'
import {Button, Card, Col, Container, Form, Image, ListGroup, Row} from "react-bootstrap";
import { connect } from 'react-redux'
import {Action, Dispatch} from "redux";
import {AppPageWrapper} from "../NavMenu/AppPageWrapper";
import {AppState, AssignedClinic, WorkforceClinicPortal} from "../../AppState";
import {SelectCompany} from "../../actions/WorkforceClinicAction";
import { CompareAccounts, SelectedAccountName } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"

export interface CompanySelectionProps{

}
export interface CompanySelectionAppStateProps{
    selectableCompanies?: WorkforceClinicPortal[];
}
export interface CompanySelectionDispatchProps{
    selectCompany: (company: string, companyLink: string) => void
}
export class CompanySelection extends Component<CompanySelectionProps & CompanySelectionAppStateProps& CompanySelectionDispatchProps>{

    selectCompany = (company: AssignedClinic) => {
        this.props.selectCompany(company.ParticipationID, company.Link);
    }

    selectPortal = (portal: WorkforceClinicPortal) => {
        this.props.selectCompany(portal.ParticipationID || '', portal.Link || '');
    }

    render() {
        const companies = (this.props.selectableCompanies?.sort((a, b) => (a.ImplementationName || "").localeCompare(b.ImplementationName || "")) || []).map(
            (portal, portalIndex) => {
                const childCompanies =  portal.AssignedClientDetailsOfClinic.filter(company => !company.LocationID).sort(CompareAccounts).map((clinic, clinicIndex) => {
                    return (<ListGroup.Item key={portalIndex + "-" + clinicIndex}>
                        <Button block={true} onClick={() => {
                            this.selectCompany(clinic)
                        }} variant="outline-primary">{SelectedAccountName(clinic)}</Button>
                    </ListGroup.Item>);
                });
                return <ListGroup key={`${portal.ImplementationName}-${portalIndex}`}>
                        <ListGroup className="m-2">
                            {childCompanies}
                        </ListGroup>
                    </ListGroup>
            }
        );
        return <AppPageWrapper showNav={false}  hideLogo={true} >
            <Container fluid className="text-center">
                <div className="m-2">
                    <Row>
                        <Col md={{ span: 4, offset: 4 }}>
                            <Card>
                                <Card.Header className="bg-light">Company Selection</Card.Header>
                                <Card.Body>
                                    {companies}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </Container>
        </AppPageWrapper>
    }
}
function mapStateToProps(state: AppState): CompanySelectionAppStateProps {
    return {
        selectableCompanies: state.Workforce1Companies.visibleCompanies
    }
}
function mapDispatchProps(dispatch: Dispatch<Action>): CompanySelectionDispatchProps {
    return {
        selectCompany: (company: string, companyLink: string) => (dispatch(SelectCompany(company, companyLink))),
    }
}
export default connect<CompanySelectionAppStateProps, CompanySelectionDispatchProps,CompanySelectionProps, AppState>(
    mapStateToProps, mapDispatchProps)(CompanySelection);
